import { render, staticRenderFns } from "./groupGoods.edit.vue?vue&type=template&id=9507a768&scoped=true"
import script from "./groupGoods.edit.vue?vue&type=script&lang=js"
export * from "./groupGoods.edit.vue?vue&type=script&lang=js"
import style0 from "./groupGoods.edit.vue?vue&type=style&index=0&id=9507a768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9507a768",
  null
  
)

export default component.exports